import MoveWizardStep4 from './move-wizard-step-4';
export default MoveWizardStep4;
